import config from './config';
import axios from 'axios';

const API_KEY = '49b04966-3a4c-11e7-9fb0-1b2783622b34';

export default {
  get: function (guid) {
    return new Promise(function (resolve, reject) {
      axios.get(config.getURI('/api/surveys/' + guid, `project=${config.project}`))
        .then(response => {
          return resolve(
            response.data
          );
        }) // includes id field
        .catch(error => {
          console.error(error.statusText);
          reject(error);
        });
    });
  },
  getSummary: function (guid) {
    return new Promise(function (resolve, reject) {
      axios.get(config.getURI(`/api/surveys/${guid}/summary`, `project=${config.project}`))
        .then(response => {
          return resolve(
            response.data
          );
        }) // includes id field
        .catch(error => {
          console.error(error.statusText);
          reject(error);
        });
    });
  },
  postAnswer: function (surveyGuid, personGuid, questionGuid, answer) {
    return new Promise((resolve, reject) => {
      var authHeader = {apikey: API_KEY};
      var url = config.getURI(`/api/surveys/${surveyGuid}/person/${personGuid}/answer/${questionGuid}`, `project=${config.project}`);

      if (answer.extras && typeof answer.extras !== 'string') {
        answer.extras = JSON.stringify(answer.extras);
      }

      var data = {
        answer: answer
      };

      axios({
        method: 'POST',
        url: url,
        data: data,
        headers: authHeader
      })
        .then(response => {
          // console.log('stored answer for question %s for person %s', questionGuid, personGuid, response);
          resolve(response.data);
        })
        .catch( (error) => {
          reject(error);
        });
    });
  },
  postBulkAnswers: function (surveyGuid, personGuid, answers) {
    // answers argument:
    //     [
    //       {
    //         "question": "84d59391-e82b-4fae-b6f2-06038f7845e1",
    //         "answer":"This is my first bulk answer",
    //         "extras": JSON.stringify({'a':111, 'b':1111})
    //       },
    //       {
    //         "question": "58b78231-a941-4373-95ed-299650d2ce2a",
    //         "answer":"My second bulk answer",
    //         "extras": JSON.stringify({'a': 222, 'b': 2222})
    //       }
    //     ]
    // };

    return new Promise((resolve, reject) => {
      var authHeader = {apikey: API_KEY};
      var url = config.getURI(`/api/surveys/${surveyGuid}/person/${personGuid}/answers`, `project=${config.project}`);

      // extras JSON inside the object needs to be stringified for posting as part of object
      answers = answers.map(a => {
        var b = a;
        if (b.extras && typeof b.extras !== 'string') {
          b.extras = JSON.stringify(b.extras);
        }
        return b;
      });

      var data = {
        answers: answers
      };

      axios({
        method: 'POST',
        url: url,
        data: data,
        headers: authHeader
      })
        .then(response => {
          // console.log('stored answers for bulk questions for person', answers, personGuid, response);
          resolve(response.data);
        })
        .catch( (error) => {
          reject(error);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/lib/surveys.js